import { useController, useFormContext } from 'react-hook-form';
import { TimezoneSelect, TimezoneSelectProps } from 'components/timezone-select';

interface TimezoneSelectFormValues {
    timezone: string;
}

const CampaignSettingsTimezoneSelect = (props: TimezoneSelectProps) => {
    const { onChange: onChangeConsumer } = props;
    const { control } = useFormContext<TimezoneSelectFormValues>();
    const { field } = useController({ control, name: 'timezone' });

    return (
        <TimezoneSelect
            value={field.value}
            onChange={value => {
                field.onChange(value);
                onChangeConsumer?.(value);
            }}
        />
    );
};

export type { TimezoneSelectFormValues };
export { CampaignSettingsTimezoneSelect };
